interface TextAreaProps {
  title: string;
  placeholder: string;
  state: string;
  setState: React.Dispatch<React.SetStateAction<string>>;
  textAreaClassName?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  title,
  placeholder,
  state,
  setState,
  textAreaClassName = "w-full h-[151px] justify-start items-start gap-2 inline-flex"
}) => {
  return (
    <div className="self-stretch h-fit flex-col justify-start items-start gap-1.5 flex">
      <div className="text-neutral-500 text-xs font-normal font-sans uppercase leading-[14px] tracking-wide">
        {title}
      </div>
      <div className="self-stretch grow shrink basis-0 bg-neutral-50 rounded-lg flex-col justify-start items-start flex">
        <div className={textAreaClassName}>
          <textarea
            value={state}
            onChange={(event) => setState(event.target.value)}
            className="grow basis-0 self-stretch p-3 bg-neutral-50 text-neutral-700 text-base font-normal font-sans leading-[19px] resize-none placeholder:text-neutral-300 focus:outline-none custom-scroll"
            placeholder={placeholder}
          />
        </div>
      </div>
    </div>
  );
};

export default TextArea;
